import React, { useState, useEffect, useContext } from "react"
import Context from "../utils/Context"
import ShowMessage from "./ShowMessage"
//import MissionDraggableTagList from "./elements/MissionDraggableTagList"
import DraggableTagList from "./elements/DraggableTagList"

export default function ModalMission() {

  const context = useContext(Context)
  const defaultMission = { robot: context.selectedRobot.name, mapIndex: context.mapIndex }
  const [selectedMission, setSelectedMission] = useState(defaultMission)
  const [selectedAction, setSelectedAction] = useState()
  const [inputValue, setInputValue] = useState()
  const [saveState, setSaveState] = useState(false)
  const [isEditing, setIsEditing] = useState(false)
  const [removeSelected, setRemoveSelected] = useState(false)
  const [cacheAction, setCacheAction] = useState([])
  const [selectedMissionType, setSelectedMissionType] = useState("")
  const [selectedDestination, setSelectedDestination] = useState("")
  const [selectedLevel, setSelectedLevel] = useState("")

  // saveState
  useEffect(() => {
    console.log(selectedMission)
    setSaveState(
      selectedMission &&
        selectedMission.name &&
        selectedMission.actions &&
        selectedMission.actions.length > -1
        ? true
        : false
    )
  }, [selectedMission])



  let modalMessage
  switch (selectedAction?.name) {
    case "pause": modalMessage = "Minimal value is 0.1"; break
    case "desinfect-uv": modalMessage = "Minimal value is 0.1"; break
    case "desinfect-all": modalMessage = "Minimal value is 0.1"; break
    case "rotate": modalMessage = "Insert an integer angle in degrees"; break
    default:
  }

  const getCache = (action) => {

    const found = cacheAction.find(element => element.action === action)

    return found ? found.value : null

  }

  const validAction = (action, value) => {

    var validate = cacheAction

    const indx = validate.findIndex(v => v.action === action.name)
    if (~indx) {
      validate.splice(indx, 1)
      validate.push({ action: action.name, value: value })
      setCacheAction(validate)
    } else {
      validate.push({ action: action.name, value: value })
      setCacheAction(validate)
    }

  }


  // select mission
  const selectMission = (event) => {
    setRemoveSelected(false)
    const mission =
      event.target.value === ""
        ? defaultMission
        : context.availableMissions.find((mission) => mission.name === event.target.value)
    setSelectedMission(mission)
    setIsEditing(true)

  }

  // handle mission selection
  const handleChange = async (target) => {
    setSelectedMission((selected) => ({ ...selected, [target.id]: target.value }))

  }

  // insert or update item to array helper
  const pushToArray = (obj, arr) => {
    const index = arr.findIndex((e) => e.name === obj.name)
    if (index === -1) {
      arr.push(obj)
    } else {
      arr[index] = obj
    }
    return arr
  }

  const convertActionsNewMission = (nameMission, actions) => {
    const newActions = actions.map((action) => {
      return {
        id: nameMission,
        command: action.command,
        value: action.value,
        level: action.level,
        type: "",
      };
    });
    return newActions;
  };

  // save mission
  const save = async () => {
    let msg = "Please fill mission name and add at least 1 action"
    let typeMsg = "error"

    if (saveState) {
      const newMission = {
        name: selectedMission.name,
        actions: selectedMission.actions,
      }

      const updatedMissions = pushToArray(newMission, [...context.availableMissions])
      context.actions.setAvailableMissions(updatedMissions)
      msg = "Mission saved"
      typeMsg = "success"
    }

    context.actions.setMessage({ message: msg, type: typeMsg })
  }

  // select action
  const selectAction = (event) => {

    setInputValue(null)

    setSelectedAction(null)
    if (!selectedMission) setSelectedMission(defaultMission)

    const action = context.availableActions.find(
      (action) => action.name === event.target.value
    )

    //console.log('selecting action', action, event.target.value)


    setInputValue(getCache(action.name))
    setSelectedAction(action)

  }

  const validateRules = () => {

    if ((selectedAction && selectedAction.needsValue && inputValue) || (selectedAction && !selectedAction.needsValue)) {

      if (selectedAction.name === "pause") {
        if (inputValue > 0) {
          return true
        } else {
          context.actions.setMessage({ message: modalMessage, type: "error" })
          return false
        }
      } else if (selectedAction.name === "desinfect-uv" || selectedAction.name === "desinfect-all") {
        if (inputValue > 0) {
          return true
        } else {
          context.actions.setMessage({ message: modalMessage, type: "error" })
          return false
        }
      } else if (selectedAction.name === "rotate") {
        if (Number.isInteger(Number(inputValue))) {
          return true
        } else {
          context.actions.setMessage({ message: modalMessage, type: "error" })
          return false
        }
      } else if (inputValue === "Select destination..." || inputValue === "Select event...") {
        context.actions.setMessage({ message: "Invalid action.", type: "error" })
        return false
      }
      else {
        return true
      }

    } else {
      context.actions.setMessage({ message: "Invalid action.", type: "error" })
      return false
    }
  }


  // add action
  const addAction = () => {
    if (!selectedMissionType || !selectedDestination || !selectedLevel) {
      context.actions.setMessage({ message: "Please fill all fields before adding an action.", type: "error" })
      return
    }

    const newAction = {
      id: `${selectedMission.name}-${selectedMission.actions?.length || 0}`,
      command: selectedMissionType,
      value: selectedDestination,
      level: selectedLevel,
    }

    const updatedActions = selectedMission.actions
      ? [...selectedMission.actions, newAction]
      : [newAction]

    setSelectedMission({ ...selectedMission, actions: updatedActions })
  };

  // remove action
  const removeAction = (actionId) => {
    const updatedActions = selectedMission.actions.filter((action) => action.id !== actionId)
    setSelectedMission({ ...selectedMission, actions: updatedActions })
  }

  // delete mission
  const remove = () => {
    const missionIndex = context.availableMissions.findIndex(
      (mission) => mission.name === selectedMission.name
    )

    if (missionIndex !== -1) {
      const newMissions = [...context.availableMissions]
      newMissions.splice(missionIndex, 1)
      context.actions.setAvailableMissions(newMissions)
      clear()
      context.actions.setMessage({ message: "Mission deleted.", type: "success" })
      setRemoveSelected(true)
    } else {
      context.actions.setMessage({ message: "Mission not found.", type: "error" })
    }
  }

  // clear for new mission input
  const clear = () => {
    setSelectedMission(defaultMission);
    setSelectedMissionType(""); // Reset Mission Type to default
    setSelectedDestination(""); // Reset Destination to default
    setIsEditing(true);
    setRemoveSelected(false); // Ensure dropdown resets properly
  }

  // handle select values
  const handleSelectValue = (event) => {

    validAction(selectedAction, event.target.value)
    setInputValue(event.target.value)

  }



  return (
    <div className="modal is-active">
      <div className="modal-background"></div>
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>

        <header className="modal-card-head">
          <p className="modal-card-title">Missions</p>
          <button
            className="delete"
            aria-label="close"
            onClick={() => context.actions.setModalState({ ...context.modalState, missions: false })}
          ></button>
        </header>

        <section className="modal-card-body">

          <div className="field mb-5">
            <label className="label">Missions</label>
            <div className="control">
              <button className="button is-success" onClick={clear} style={{ marginRight: "1rem" }}>
                Create new Mission
              </button>
              <div className="select">
                <select name="mission" onChange={selectMission}
                  defaultValue={"Edit mission..."}>
                  {removeSelected ? (
                    <option selected disabled>Edit mission...</option>
                  ) :
                    <option disabled>Edit mission...</option>
                  }
                  {context.availableMissions?.map((item, i) =>
                    //item.robot === context.selectedRobot.name && item.mapIndex === context.mapIndex && (
                      <option key={i}>
                        {item.name}
                      </option>
                    )
                  //)
                    }
                </select>
              </div>
            </div>
          </div>

          <div className="field mb-5">
            <label className="label">Name</label>
            <div className="control">
              <input
                id="name"
                type="text"
                className="input"
                placeholder={"New mission name..."}
                value={selectedMission && selectedMission.name ? selectedMission.name : ""}
                onChange={(event) => handleChange(event.target)}
              />
            </div>
          </div>

          <div className="field mb-5">
            <label className="label">Mission Type</label>
            <div className="select">
              <select
                value={selectedMissionType || "Select mission type..."}
                onChange={(e) => setSelectedMissionType(e.target.value)}
                id="missionType"
                name="missionType"
              >
                <option disabled value="Select mission type...">Select mission type...</option>
                {context.missionType?.map((type, i) => (
                  <option key={i} value={type.name}>
                    {type.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="field mb-5">
            <label className="label">Destination</label>
            <div className="select">
              <select
                value={selectedDestination || "Select destination..."}
                onChange={(e) => setSelectedDestination(e.target.value)}
                id="destination"
                name="destination"
              >
                <option disabled value="Select destination...">Select destination...</option>
                {context.maps && context.konvaPoints.map((item, i) => {
                    return (
                      <option key={i} value={item.name}>
                        {item.name}
                      </option>
                    )
                })}
              </select>
            </div>
          </div>
          <div className="field mb-5">
            <label className="label">Level</label>

            <div className="select mr-3">
              <select name="level"
                id="level"
                onChange={(e) => setSelectedLevel(e.target.value)}
                defaultValue={"Add Level..."} >
                  
                <option disabled>Add Level...</option>
                {context.levelValue && context.levelValue.map((item, i) => (
                  <option key={i} value={item.value}>
                    Level {item.name} - meters {item.value}
                  </option>
                ))}
              </select>
            </div>



            <button className="button is-light" onClick={addAction}>
              Add
            </button>
          </div>

          {selectedMission && selectedMission.actions && (
            <DraggableTagList
              itemList={selectedMission.actions}
              removeAction={(actionId) => removeAction(actionId)}
              saveOrder={(updatedActions) =>
                setSelectedMission({ ...selectedMission, actions: updatedActions })
              }
              renderTagContent={(action) =>
                `${action.command} - ${action.value} - ${action.level}`
              }
            />
          )}

          <div className="field mb-5">
            <div className="control">
              <button className="button is-success" onClick={save} style={{ marginRight: "1rem" }}>
                Save changes
              </button>
              {isEditing ?
                <button className="button is-danger" onClick={remove}>
                  DeleteMission
                </button>
                : null
              }
            </div>
            {selectedMission._id &&
              <div className="control">
                <button className="button is-success" onClick={remove}>
                  Delete
                </button>
              </div>
            }
          </div>

          <ShowMessage />

        </section>
      </div>
    </div>
  )
}
